const About = (props: any) => {
  return (
    <div>
      <div>
        <div>
          {/* <div className="center-greetings">
            <h1>회사소개</h1>
            <hr></hr>
          </div> */}
          {/* <div className="msg">
            <span>깨끗하고 건강한 물을 드리는 생수전문 업체 </span>
            <span style={{ fontWeight: "700" }}>생수드림</span>
            <span> 입니다.</span>
          </div> */}
        </div>
        <div className="about-img-form">
          <img src="/img/about2.jpg" alt="about"></img>
        </div>
        {/* <div className="about-img-form">
          <img src="/img/about1.jpg" alt="about"></img>
        </div> */}

        <div
          className="msg"
          style={{
            marginTop: "60px",
            marginBottom: "20px",
            textAlign: "left",
            padding: "0px 30px",
          }}
        >
          <span>안녕하세요. {props.name}생수 입니다.</span>
          <br />
          <br />
          <span> 고객님의 원하시는 생수가 준비되어있습니다.</span>
          <br />
          <br />
          <span>
            고객님의 건강을 먼저 생각하는 기업으로서 깨끗하고 믿을 수 있는
            제품으로 보답하겠습니다. 앞으로도 많은 성원 부탁드립니다.
          </span>
          <br />
          <br />
          <span>감사합니다.</span>
        </div>
      </div>
    </div>
  );
};

export default About;
